import React, { useCallback, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useCompany } from "../../context/CompanyContext";
import CRMSidebar from "../components/CRMSidebar";
import CRMTopbar from "../components/CRMTopbar";
import { bootstrapCrmForCompany } from "../services/crmBootstrapService";
import "../styles/crm.css";

const CRMLayout = () => {
  const { companyId } = useCompany();
  const [bootstrapping, setBootstrapping] = useState(false);
  const [bootstrapMessage, setBootstrapMessage] = useState("");

  const bootstrap = useCallback(async () => {
    if (!companyId) {
      return;
    }

    setBootstrapping(true);
    setBootstrapMessage("");

    try {
      await bootstrapCrmForCompany(companyId);
    } catch (error) {
      setBootstrapMessage(error.message || "Failed to initialize CRM");
    } finally {
      setBootstrapping(false);
    }
  }, [companyId]);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  return (
    <div className="crm-layout">
      <CRMSidebar />

      <div className="crm-main-area">
        <CRMTopbar />

        <div className="crm-page-content">
          {bootstrapping ? (
            <div className="crm-message">Preparing CRM workspace...</div>
          ) : null}

          {bootstrapMessage ? (
            <div className="crm-message">{bootstrapMessage}</div>
          ) : null}

          {!bootstrapping && !bootstrapMessage ? <Outlet /> : null}
        </div>
      </div>
    </div>
  );
};

export default CRMLayout;
